/**
 * 认证中心（single-sign）接口封装
 * 功能：提供菜单列表与按钮权限查询，均硬编码 system_id=152
 */
import request from "../utils/request"
import config from '@/config/auth_config'
const rootApi = config.serverPath.server;
//获取菜单
export const getMenuList = () => {
  let para = {}
  para.system_id = 152
  return request.get(rootApi + "/single-sign/user", {
    params: para
  });
};
//获取按钮权限
export const getButton = (para) => {
  para.system_id = 152
  return request.get(rootApi + "/single-sign/getmenulist", {
    params: para
  });
};